import axios from "axios";
import { getUserFromLocalStorage } from "utils/localStorage";

import { transientJobUrls } from "../api/urls";

type FetchStorageFileParams = {
  onProgress?: (percentage: number) => void;
  path: string;
  signal?: AbortSignal;
};

export const fetchStorageFile = async ({ onProgress, path, signal }: FetchStorageFileParams) => {
  const user = getUserFromLocalStorage();
  const accessToken = typeof user.access_token === "string" ? user.access_token : "";
  const response = await axios.get<Blob>(transientJobUrls.fileDownload(path), {
    headers: { Authorization: accessToken ? `Bearer ${accessToken}` : "" },
    onDownloadProgress: (event) => {
      if (!event.total) return;
      onProgress?.(Math.round((event.loaded / event.total) * 100));
    },
    responseType: "blob",
    signal,
  });
  return response.data;
};
